import { render, staticRenderFns } from "./EZCardBindingMoovo.vue?vue&type=template&id=10c618f7&scoped=true"
import script from "./EZCardBindingMoovo.vue?vue&type=script&lang=js"
export * from "./EZCardBindingMoovo.vue?vue&type=script&lang=js"
import style0 from "./EZCardBindingMoovo.vue?vue&type=style&index=0&id=10c618f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c618f7",
  null
  
)

export default component.exports